<template>
   <q-card>
        <q-card-section>
            <q-toolbar>
               
                <q-toolbar-title>
                    Deteccion de errores en el catálogo
                </q-toolbar-title>
                <q-btn round color="red" icon="mdi-close" dense @click="cierraVentana()">
                    <q-tooltip>
                        Cerrar
                    </q-tooltip>
                </q-btn>
            </q-toolbar>
            <q-separator class="full-width" color="primary" inset size="4px" />
        </q-card-section>
        <q-card-section>

        <!-- DIALOG RESULTADOS DE CORRECCIÓN -->
        <q-dialog v-model="dialogResultados" persistent>
            <q-card style="  border-radius: 16px;">
                <q-card-section style="background:#1a1a2e; border-radius:16px 16px 0 0">
                    <div class="row items-center justify-between">
                        <div class="text-h6 text-white">Resultados de Corrección</div>
                        <q-btn flat round dense icon="mdi-close" color="white" v-close-popup />
                    </div>
                </q-card-section>
                <q-card-section class="q-pa-md">
                    <q-list separator>
                        <q-item v-for="r in resultados" :key="r.numCuenta + r.tipoError">
                            <q-item-section avatar>
                                <q-icon
                                    :name="iconoEstado(r.estado)"
                                    :color="colorEstado(r.estado)"
                                    size="22px" />
                            </q-item-section>
                            <q-item-section>
                                <q-item-label class="text-weight-bold">{{ r.numCuenta }}</q-item-label>
                                <q-item-label caption>{{ r.mensaje }}</q-item-label>
                            </q-item-section>
                            <q-item-section side>
                                <q-badge :color="colorEstado(r.estado)" :label="r.estado" />
                            </q-item-section>
                        </q-item>
                    </q-list>
                </q-card-section>
                <q-card-section class="q-pt-none">
                    <div class="row q-gutter-sm justify-end resumen-chips">
                        <q-chip color="green-2" text-color="green-9" icon="mdi-check-circle">
                            {{ resultados.filter(r => r.estado === 'OK').length }} corregidos
                        </q-chip>
                        <q-chip color="orange-2" text-color="orange-9" icon="mdi-alert-circle">
                            {{ resultados.filter(r => r.estado === 'MANUAL').length }} manuales
                        </q-chip>
                        <q-chip color="grey-3" text-color="grey-8" icon="mdi-skip-next-circle">
                            {{ resultados.filter(r => r.estado === 'SKIP').length }} omitidos
                        </q-chip>
                    </div>
                </q-card-section>
                <q-card-actions align="right" class="q-px-md q-pb-md">
                    <q-btn unelevated color="primary" label="Cerrar" style="border-radius:10px"
                        @click="dialogResultados = false; getErrores()" />
                </q-card-actions>
            </q-card>
        </q-dialog>

        <!-- CABECERA -->
        <div class="val-header q-mb-lg">
            <div>
                <div class="val-title">Validación de Catálogo de Cuentas</div>
                <div class="val-sub">Detecta y corrige inconsistencias en el catálogo contable</div>
            </div>
            <div class="row q-gutter-sm">
                <q-btn unelevated color="primary" icon="mdi-magnify-scan" label="Detectar errores"
                    :loading="loadingDetectar" @click="getErrores()" style="border-radius:10px" />
                <q-btn unelevated color="positive" icon="mdi-wrench" label="Corregir seleccionados"
                    :disable="seleccionados.length === 0" :loading="loadingCorregir"
                    @click="corregirSeleccionados()" style="border-radius:10px" />
            </div>
        </div>

        <!-- RESUMEN DE ERRORES -->
        <div v-if="errores.length > 0" class="row q-gutter-md q-mb-lg">
            <div class="resumen-card" v-for="grupo in resumenGrupos" :key="grupo.tipo">
                <div class="resumen-dot" :style="{ background: colorTipo(grupo.tipo) }"></div>
                <div>
                    <div class="resumen-num">{{ grupo.cantidad }}</div>
                    <div class="resumen-label">{{ labelTipo(grupo.tipo) }}</div>
                </div>
            </div>
        </div>

        <!-- TABLA DE ERRORES -->
        <q-table
            class="shadow-0 header-tabla"
            :data="errores"
            :columns="columns"
            :loading="loadingDetectar"
            :pagination="initialPagination"
            :filter="filter"
            row-key="index"
            selection="multiple"
            :selected.sync="seleccionados"
            no-data-label="Sin errores detectados — el catálogo está correcto"
        >
            <template v-slot:loading>
                <q-inner-loading showing color="primary" />
            </template>

            <template v-slot:top>
                <div class="row full-width items-center q-gutter-sm">
                    <div class="col">
                        <q-input filled dense v-model="filter" placeholder="Buscar..." debounce="300">
                            <template v-slot:append>
                                <q-icon name="search" />
                            </template>
                        </q-input>
                    </div>
                    <!-- <q-btn-toggle
                        v-model="filtroTipo"
                        flat rounded
                        :options="opcionesFiltro"
                        color="grey-6"
                        toggle-color="primary"
                    /> -->
                    <q-btn flat round icon="mdi-checkbox-multiple-marked"
                        color="primary" @click="seleccionarTodos()">
                        <q-tooltip>Seleccionar todos</q-tooltip>
                    </q-btn>
                    <q-btn flat round icon="mdi-checkbox-multiple-blank-outline"
                        color="grey-6" @click="seleccionados = []">
                        <q-tooltip>Deseleccionar todos</q-tooltip>
                    </q-btn>
                </div>
            </template>

            <template v-slot:body="props">
                <q-tr :props="props" :class="{ 'row-selected': props.selected }">
                    <q-td auto-width>
                        <q-checkbox v-model="props.selected" />
                    </q-td>
                    <q-td key="tipoError" :props="props">
                        <q-badge :style="{ background: colorTipo(props.row.tipoError) }"
                            :label="labelTipo(props.row.tipoError)" />
                    </q-td>
                    <q-td key="numCuenta" :props="props">
                        <span class="text-weight-bold font-mono">{{ props.row.numCuenta }}</span>
                    </q-td>
                    <q-td key="descripcion" :props="props">{{ props.row.descripcion }}</q-td>
                    <q-td key="detalle" :props="props">
                        <span class="text-caption text-grey-7">{{ props.row.detalle }}</span>
                    </q-td>
                    <q-td key="corregible" :props="props" auto-width>
                        <q-icon
                            :name="props.row.tipoError === 'PADRE_NO_EXISTE' ? 'mdi-hand-back-right' : 'mdi-auto-fix'"
                            :color="props.row.tipoError === 'PADRE_NO_EXISTE' ? 'orange' : 'green'"
                            size="20px">
                            <q-tooltip>
                                {{ props.row.tipoError === 'PADRE_NO_EXISTE'
                                    ? 'Requiere corrección manual'
                                    : 'Corrección automática disponible' }}
                            </q-tooltip>
                        </q-icon>
                    </q-td>
                </q-tr>
            </template>

            <template v-slot:no-data="{ message }">
                <div class="full-width column flex-center q-pa-xl text-grey-5">
                    <q-icon name="mdi-check-circle-outline" size="64px" color="positive" class="q-mb-md" />
                    <div class="text-h6">{{ message }}</div>
                </div>
            </template>
        </q-table>
    </q-card-section>
    </q-card>
</template>

<script>
import axios from 'axios'
import { QSpinnerCube } from 'quasar'

export default {
    data() {
        return {
            errores:         [],
            seleccionados:   [],
            resultados:      [],
            loadingDetectar: false,
            loadingCorregir: false,
            dialogResultados: false,
            filter:          '',
            filtroTipo:      'TODOS',
            initialPagination: {
                sortBy: 'tipoError',
                descending: false,
                page: 1,
                rowsPerPage: 10
            },
            columns: [
                { name: 'tipoError',   align: 'left',   label: 'Tipo de Error',  field: 'tipoError',   sortable: true },
                { name: 'numCuenta',   align: 'left',   label: 'Núm. Cuenta',    field: 'numCuenta',   sortable: true },
                { name: 'descripcion', align: 'left',   label: 'Descripción',    field: 'descripcion', sortable: true },
                { name: 'detalle',     align: 'left',   label: 'Detalle',        field: 'detalle',     sortable: false },
                { name: 'corregible',  align: 'center', label: 'Corrección',     field: 'tipoError',   sortable: false },
            ],
            opcionesFiltro: [
                { label: 'Todos',       value: 'TODOS' },
                { label: 'Nivel',       value: 'NIVEL_INCORRECTO' },
                { label: 'Naturaleza',  value: 'NATURALEZA_INCORRECTA' },
                { label: 'Tipo R',      value: 'PADRE_TIPO_R_CON_HIJOS' },
                { label: 'Sin padre',   value: 'PADRE_NO_EXISTE' },
            ]
        }
    },

    computed: {
        token() {
            return this.$store.state.usuario
        },
        erroresFiltrados() {
            if (this.filtroTipo === 'TODOS') return this.errores
            return this.errores.filter(e => e.tipoError === this.filtroTipo)
        },
        resumenGrupos() {
            const grupos = {}
            this.errores.forEach(e => {
                if (!grupos[e.tipoError]) grupos[e.tipoError] = 0
                grupos[e.tipoError]++
            })
            return Object.entries(grupos).map(([tipo, cantidad]) => ({ tipo, cantidad }))
        }
    },

    methods: {
        async getErrores() {
            this.loadingDetectar = true
            this.errores       = []
            this.seleccionados = []
            try {
                const { data } = await axios.get(
                    `CatalogoCuentas/GetErrores/erp_${this.token.rfc}`
                )
                // Agregar índice para row-key
                this.errores = data.map((e, i) => ({ ...e, index: i }))

                if (this.errores.length === 0) {
                    this.$q.notify({ type: 'positive', message: 'No se encontraron errores. El catálogo está correcto.' })
                } else {
                    this.$q.notify({
                        type: 'warning',
                        message: `Se encontraron ${this.errores.length} errores en el catálogo.`
                    })
                }
            } catch (error) {
                console.error(error)
                this.$q.notify({ type: 'negative', message: 'Error al detectar errores.' })
            } finally {
                this.loadingDetectar = false
            }
        },

        async corregirSeleccionados() {
            if (this.seleccionados.length === 0) return

            this.$q.loading.show({
                spinner: QSpinnerCube,
                spinnerColor: 'primary',
                spinnerSize: 140,
                message: `Corrigiendo ${this.seleccionados.length} errores...`,
                messageColor: 'white'
            })

            try {
                const { data } = await axios.post(
                    `CatalogoCuentas/PostCorregirErrores/erp_${this.token.rfc}`,
                    this.seleccionados
                )
                this.resultados      = data
                this.dialogResultados = true
            } catch (error) {
                console.error(error)
                this.$q.notify({ type: 'negative', message: 'Error al corregir las cuentas.' })
            } finally {
                this.$q.loading.hide()
            }
        },

        seleccionarTodos() {
            this.seleccionados = [...this.errores]
        },

        // ── Helpers de color y label ──────────────
        colorTipo(tipo) {
            return {
                NIVEL_INCORRECTO:       '#5C6BC0',
                NATURALEZA_INCORRECTA:  '#EF9F27',
                PADRE_TIPO_R_CON_HIJOS: '#E24B4A',
                PADRE_NO_EXISTE:        '#8D6E63',
                CUENTA_DUPLICADA:       '#AD1457',
                CUENTA_A_SIN_HIJOS:'#00897B'
            }[tipo] || '#aaa'
        },

        labelTipo(tipo) {
            return {
                NIVEL_INCORRECTO:       'Nivel incorrecto',
                NATURALEZA_INCORRECTA:  'Naturaleza incorrecta',
                PADRE_TIPO_R_CON_HIJOS: 'Padre tipo R con hijos',
                PADRE_NO_EXISTE:        'Padre no existe',
                CUENTA_DUPLICADA:       'Cuenta duplicada',
            }[tipo] || tipo
        },

        colorEstado(estado) {
            return { OK: 'positive', SKIP: 'grey', MANUAL: 'warning' }[estado] || 'grey'
        },

        iconoEstado(estado) {
            return {
                OK:     'mdi-check-circle',
                SKIP:   'mdi-skip-next-circle',
                MANUAL: 'mdi-hand-back-right'
            }[estado] || 'mdi-help-circle'
        },
        cierraVentana() {
            this.$emit('cierraVentana')
        },
    }
}
</script>

<style scoped>
.val-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
    gap: 16px;
}

.val-title {
    font-size: 22px;
    font-weight: 600;
    color: #1a1a2e;
}

.val-sub {
    font-size: 13px;
    color: #aaa;
    margin-top: 2px;
}

/* Resumen chips */
.resumen-card {
    display: flex;
    align-items: center;
    gap: 12px;
    background: #fff;
    border: 0.5px solid #e3e3e3;
    border-radius: 12px;
    padding: 12px 18px;
    min-width: 160px;
}

.resumen-dot {
    width: 10px;
    height: 10px;
    border-radius: 50%;
    flex-shrink: 0;
}

.resumen-num {
    font-size: 22px;
    font-weight: 700;
    color: #111;
    line-height: 1;
}

.resumen-label {
    font-size: 11px;
    color: #aaa;
    text-transform: uppercase;
    letter-spacing: .05em;
    font-weight: 600;
    margin-top: 2px;
}

/* Fila seleccionada */
.row-selected {
    background: #f0f4ff !important;
}

.font-mono {
    font-family: 'Courier New', monospace;
    font-size: 13px;
}

.resumen-chips {
    padding-top: 0;
}
</style>